
import {
  REFRESH_TASKS,
  ADD_TASK,
  UPDATE_TASK,
  DELETE_TASK,
  SET_SELECTED_TASK
} from "../actions/task.action";

const initialState = {
  tasks: [],
};

const taskReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFRESH_TASKS: 
      return {
        ...state,
        tasks: action.tasks,
      };
    case ADD_TASK:
      return {
        ...state,
        tasks: [...state.tasks, action.task],
      };
    case UPDATE_TASK:
      return {
        ...state,
        tasks: state.tasks.map((task) =>
          task.id === action.task.id ? action.task : task
        ),
      };
    case DELETE_TASK:
      return {
        ...state,
        tasks: state.tasks.filter((task) => task.id !== action.taskId),
      };
    case SET_SELECTED_TASK:
      return {
        ...state,
        selectedTask: action.taskId,
      };
    default:
      return state;
  }
};

export default taskReducer;
